import {
  FACompDetailsType,
  FACompResultDetailsType,
  FACompResultBlogContentType,
} from "../../types/blog/blogContentTypes";
import {
  filterCompRoundDetails,
  filterCompResultDetails,
  getFAComp,
  getFACompByType,
} from "../filters/filterPostsRefData";
import { FACompsBySeasonDate } from "./postReferenceData";
import { FACompBlogContentType } from "../../types/blog/blogContentTypes";
import { formatDate } from "common";

export const generateCompResultBlogPost = (
  season: string,
  compName: string,
  clubName: string,
  losingClubName: string
): FACompResultBlogContentType | null => {
  let compRoundDetails: FACompResultDetailsType | null =
    filterCompResultDetails(season, compName);
  if (compRoundDetails === null) return null;
  const today = new Date();
  let generateCompResultBlogPost: FACompResultBlogContentType = {
    season: compRoundDetails.season,
    comp: compRoundDetails.comp,
    clubs: compRoundDetails.clubs,
    winningClub: clubName,
    losingClub: losingClubName,
    aet: false,
    pens: false,
    score: "",
    isPublished: false,
    title: "Champions",
    pubDate: formatDate(today.toDateString()),
    modifiedDate: formatDate(today.toDateString()),
    excerpt: "",
    categories: getFACompByType(compRoundDetails.comp)!.categories,
    content: "",
    winningClubDetail: null,
    losingClubDetail: null,
  };
  return generateCompResultBlogPost;
};
